export default __webpack_public_path__ + "static/media/offline.2d497b76.png";